import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import VueRouterMultiView from 'vue-router-multi-view'
import VueTheMask from 'vue-the-mask'
import VueI18n from 'vue-i18n'
import messages from './translations/main'
import { helpCenterLinksDirective } from '@/utils/helpCenter'
import * as Sentry from '@sentry/vue'
import STGallery from '@scantrust/st-gallery'
import { default as axios }  from './utils/axios.instances' // eslint-disable-line
import Api from './api.js'

const axiosInstance = axios.getSTAxios() // eslint-disable-line

Vue.use(VueTheMask)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.directive('help-center-links', helpCenterLinksDirective)
Vue.use(VueRouterMultiView)
Vue.use(VueI18n)
Vue.use(STGallery)

Vue.prototype.$axios = axiosInstance
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  ...messages
})
Vue.prototype.$trnslt = i18n

if (Api.sentry_key) {
  Sentry.init({
    Vue,
    dsn: Api.sentry_key,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  })
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
